// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationReviewDetals_container__Zi1lA"};